export default function InnovationSection() {
  return (
    <section className="relative w-full py-24 md:py-32 lg:py-40 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-1/2 bg-background-50 rounded-lg overflow-hidden min-h-[400px] lg:min-h-[500px] relative">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20technical%20linework%20pattern%20in%20dark%20charcoal%20and%20warm%20copper%20tones%2C%20geometric%20grid%20with%20intersecting%20lines%2C%20clean%20engineering%20aesthetic%2C%20no%20people%2C%20no%20text%2C%20sophisticated%20tech%20texture%2C%20subtle%20depth%20and%20layering&width=800&height=600&seq=innovation-dirbtuviu-2026&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>
          </div>
          <div className="w-full lg:w-1/2 flex flex-col justify-center px-0 lg:px-14 py-10 lg:py-0">
            <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-400 font-medium">
              Continuous Evolution
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Innovation through disciplined engineering
            </h2>
            <div className="mt-8 space-y-5">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                The team actively explores new technologies and evolves internal processes to maintain high technical excellence. This is not innovation for its own sake — it is a structured approach to ensuring that every system benefits from the latest advances in software engineering.
              </p>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                Workflow improvements are measured and deliberate. Each refinement — whether in testing strategy, deployment pipelines, or code review practices — is evaluated against clear benchmarks for quality, speed, and reliability.
              </p>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                By combining deep platform expertise with an openness to new ideas, the team delivers solutions that are both grounded in proven engineering principles and ready for the challenges of tomorrow.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}